import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Shop from '../views/Shop.vue'
import ProductDetail from '../views/ProductDetail.vue'
import Cart from '../views/Cart.vue'
import NotFound from '../views/PageNotFound.vue'
import AboutUs from '../views/AboutUs.vue'
import Contactus from '../views/Contactus.vue'
import Faq from '../views/faq.vue'
import Shippingreturns from '../views/Shippingreturns.vue'
import Workshop from '../views/Workshop.vue'
import OrderSuccess from '../views/OrdersSccess.vue'
import WorkshopPaymentSuccess from '../views/WorkshopPaymentSuccess.vue'
import Checkout from '../views/Checkout.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/shop/:slug?',
    name: 'ShopBySlug',
    component: Shop,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/product/:slug',
    name: 'Product Detail',
    component: ProductDetail,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/order-success',
    name: 'Order Success',
    component: OrderSuccess,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/workshop-payment-success',
    name: 'Workshop Payment Success',
    component: WorkshopPaymentSuccess,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/workshop',
    name: 'Workshop',
    component: Workshop,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/about',
    name: 'About Us',
    component: AboutUs,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/contact',
    name: 'Contact Us',
    component: Contactus,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/shipping-returns',
    name: 'Shipping Returns',
    component: Shippingreturns,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    // path: "*",
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
})
router.afterEach((to, from) => {
  document.title = to.meta.title;
});
export default router
